import React from 'react';
import PropTypes from 'prop-types';
import { Modal, ModalBody, Button } from 'reactstrap';

const formatCountdown = (seconds) => {
  if (seconds >= 60) {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${String(s).padStart(2, '0')}`;
  }
  return `${seconds}s`;
};

const IdleTimeoutModal = ({ countdown, onStayLoggedIn, onLogout }) => (
  <Modal isOpen centered backdrop="static" keyboard={false}>
    <ModalBody className="text-center p-4">
      <div className="mb-3">
        <i className="bx bx-time-five" style={{ fontSize: '48px', color: '#556ee6' }} />
      </div>
      <h5 className="mb-2">Session Expiring</h5>
      <p className="text-muted mb-3">Your session will expire due to inactivity.</p>
      <h2 className="text-primary mb-4">{formatCountdown(countdown)}</h2>
      <div className="d-flex justify-content-center gap-2">
        <Button color="light" onClick={onLogout} className="me-2">Log Out</Button>
        <Button color="primary" onClick={onStayLoggedIn}>Stay Logged In</Button>
      </div>
    </ModalBody>
  </Modal>
);

IdleTimeoutModal.propTypes = {
  countdown: PropTypes.number.isRequired,
  onStayLoggedIn: PropTypes.func.isRequired,
  onLogout: PropTypes.func.isRequired,
};

export default IdleTimeoutModal;
